import { apiClient } from 'modules/core/lib/mobx-rest'

import { PayrollIntegrationType } from 'modules/payroll_integrations/lib/catalog'

export enum Status {
  Unavailable = 'unavailable',
  Available = 'available',
  Done = 'done',
  Blocked = 'blocked',
}

export enum Action {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export interface Diff {
  local: string
  remote: string
}

export interface DiffFields {
  first_name?: Diff
  last_name?: Diff
  identifier_number?: Diff
  identifier_type?: Diff
  social_security_number?: Diff
}

export interface Sync {
  integration: string
  status: Status
  unavailable_fields: string[] | null
  diff_fields: DiffFields | null
  default_value: boolean
  action: Action
}

export interface SyncEmployeeCode {
  integration: string
  synced: boolean
}

interface StatusParams {
  companyId?: number
  incidenceId: string
  isBookkeeperView: boolean
  integration: PayrollIntegrationType
}

interface SyncParams {
  companyId?: number
  incidenceId: string
  isBookkeeperView: boolean
  integration: PayrollIntegrationType
}

interface SyncEmployeeCodeParams {
  companyId: number
  employeeId: number
  isBookkeeperView: boolean
}

class IncidenceSync {
  static syncPath = '/payroll_integrations/syncs'
  static syncEmployeeCode = '/payroll_integrations/a3innuva/sync_employee_code'

  async status(params: StatusParams): Promise<Sync> {
    return apiClient().get(IncidenceSync.syncPath, {
      company_id: params.companyId,
      bookkeeper_view: params.isBookkeeperView,
      incidence_id: params.incidenceId,
      integration: params.integration,
    })
  }

  async sync(params: SyncParams): Promise<Sync> {
    return apiClient().post(IncidenceSync.syncPath, {
      company_id: params.companyId,
      bookkeeper_view: params.isBookkeeperView,
      incidence_id: params.incidenceId,
      integration: params.integration,
    })
  }

  async syncEmployeeCode(params: SyncEmployeeCodeParams): Promise<SyncEmployeeCode> {
    return apiClient().post(IncidenceSync.syncEmployeeCode, {
      bookkeeper_view: params.isBookkeeperView,
      company_id: params.companyId,
      employee_ids: [params.employeeId],
    })
  }
}

export default new IncidenceSync()
